import { Badge, Flex } from '@chakra-ui/react';

import { trpcAdmin } from '../../lib/trpcAdmin';
import {
  UNIT_REQUIREMENT_KIND_COLOURS,
  unitRequirementLabel,
} from '../../components/requirements/kinds';
import { testIds } from './testIds';

export function SlideRequirementChips({
  slideId,
  unitAssessmentVersionId,
}: {
  slideId: string;
  unitAssessmentVersionId: string | null;
}) {
  const { data: linksBySlideId } = trpcAdmin.unitAssessment.getSlideRequirementLinks.useQuery(
    { unitAssessmentVersionId: unitAssessmentVersionId ?? '' },
    { enabled: unitAssessmentVersionId != null },
  );

  const links = linksBySlideId?.[slideId] ?? [];

  if (links.length === 0) {
    return null;
  }

  return (
    <Flex gap={1.5} wrap="wrap">
      {links.map((link) => (
        <Badge
          key={link.requirementId}
          colorScheme={UNIT_REQUIREMENT_KIND_COLOURS[link.kind]}
          fontFamily="mono"
          fontSize="xs"
          data-testid={testIds.slideRequirementChip}
        >
          {unitRequirementLabel(link)}
        </Badge>
      ))}
    </Flex>
  );
}
